import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

// httpOnly cookie session — `withCredentials: true` is required for the
// browser to include the cookies set by the backend on /auth/login.
// Auth tokens are NEVER stored in localStorage/sessionStorage.
const api = axios.create({
  baseURL: API,
  withCredentials: true,
});

api.interceptors.request.use((config) => {
  // Non-sensitive preference — safe to keep in localStorage.
  const locale = localStorage.getItem("acas_locale");
  if (locale) config.headers["Accept-Language"] = locale;
  return config;
});

api.interceptors.response.use(
  (r) => r,
  (err) => {
    // On 401, the cookie is invalid/expired — send the user back to login.
    // No token to remove on the client — the server clears cookies on logout.
    if (err.response?.status === 401 && !err.config.url.includes("/auth/")) {
      if (typeof window !== "undefined" && window.location.pathname !== "/giris") {
        window.location.href = "/giris";
      }
    }
    return Promise.reject(err);
  }
);

export function formatApiError(detail) {
  if (detail == null) return "Bir hata oluştu. Lütfen tekrar deneyin.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail.map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e))).join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  if (detail && typeof detail.message === "string") return detail.message;
  return String(detail);
}

export default api;
